import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { useAppDispatch } from '../../hooks'
import { userActions } from '../../store/slices/userSlice'
import { AddAccountModal, Info, Main, Statistic } from '..'

const PageWrapper = styled.div`
	min-height: 100vh;
	background: #1a1a2e;
	position: relative;
	overflow-x: hidden;

	&::before {
		content: '';
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		pointer-events: none;
		opacity: 0.6;
		background-image: 
			radial-gradient(2px 2px at 20px 30px, #eee, transparent),
			radial-gradient(2px 2px at 40px 70px, rgba(255,255,255,0.8), transparent),
			radial-gradient(1px 1px at 90px 40px, #fff, transparent),
			radial-gradient(1px 1px at 130px 80px, rgba(255,255,255,0.6), transparent),
			radial-gradient(2px 2px at 160px 30px, #ddd, transparent),
			radial-gradient(1px 1px at 200px 50px, rgba(255,255,255,0.7), transparent),
			radial-gradient(2px 2px at 250px 90px, #fff, transparent),
			radial-gradient(1px 1px at 300px 20px, rgba(255,255,255,0.5), transparent),
			radial-gradient(2px 2px at 350px 60px, #eee, transparent),
			radial-gradient(1px 1px at 400px 100px, rgba(255,255,255,0.8), transparent);
		background-repeat: repeat;
		background-size: 450px 150px;
		animation: sparkle 25s linear infinite;
	}

	@keyframes sparkle {
		0%, 100% { 
			transform: translateY(0px) translateX(0px); 
			opacity: 0.6;
		}
		25% { 
			transform: translateY(-5px) translateX(5px); 
			opacity: 0.8;
		}
		50% { 
			transform: translateY(-10px) translateX(10px); 
			opacity: 1;
		}
		75% { 
			transform: translateY(-5px) translateX(5px); 
			opacity: 0.8;
		}
	}
`

const Wrapper = styled.main`
	margin: 0 auto;
	max-width: 1520px;
	position: relative;
	z-index: 1;
`

const DashboardContainer = styled.div`
	padding-top: 70px;
	@media (max-width: 700px) {
		padding-top: 30px;
	}
`

const DashboardTitle = styled.h2`
	font-weight: 700;
	font-size: 32px;
	color: #f3f4f6;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
	margin: 0 0 30px 0;
	text-align: center;
	
	@media (max-width: 768px) {
		font-size: 24px;
		margin: 0 0 25px 0;
	}
	
	@media (max-width: 480px) {
		font-size: 20px;
		margin: 0 0 20px 0;
	}
`

const CardsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(370px, 1fr));
	gap: 30px;
	justify-content: center;
	align-items: start;
	margin-bottom: 40px;
	max-width: 800px;
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 15px;
		margin-bottom: 30px;
		max-width: 400px;
	}
	
	@media (max-width: 480px) {
		gap: 10px;
		margin-bottom: 20px;
		max-width: none;
		padding: 0 10px;
	}
`

const MainLayout = () => {
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(userActions.getDataUserData())
	}, [])

	return (
		<PageWrapper>
			<Wrapper>
				<DashboardContainer>
					<DashboardTitle>DASHBOARD</DashboardTitle>
					<CardsContainer>
						<Info />
						<Statistic />
					</CardsContainer>
				</DashboardContainer>
				<Main>
					<Outlet />
				</Main>
			</Wrapper>

			<AddAccountModal />
			<ToastContainer />
		</PageWrapper>
	)
}

export default MainLayout
